<template>
  <v-container>
    <v-row v-if="loading" justify="center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-row>
    <v-row v-else>
      <v-col
        v-for="(item, i) in items"
        :key="i"
        cols="12"
      >
        <v-card>
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-title
                class="text-h5"
              >
                {{ item.title }}
              </v-card-title>
              <v-card-subtitle> {{ item.desc }}</v-card-subtitle>
              <v-card-actions>
                <div class="text-center">
                  <v-dialog
                    v-model="dialog[i]"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ item.cta }}
                      </v-btn>
                    </template>

                    <v-card>
                      <v-card-title class="text-h5">
                        {{ item.title }}
                      </v-card-title>

                      <v-card-text>
                        <div v-html="item.content.content"></div>
                      </v-card-text>

                      <v-divider></v-divider>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          @click="$set(dialog, i, false)"
                        >
                          Fermer
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </v-card-actions>
            </div>
            <div>
              <v-img
                :src="item.src"
                contain
                max-width="200"
                width="100%"
                class="ma-4"
              />
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col v-if="items.length === 0" cols="12" class="text-center">
        <p class="grey--text">Aucun communiqué de presse disponible pour le moment.</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SectionActus',

  data: () => ({
    dialog: [],
    items: [],
    loading: false
  }),

  mounted() {
    this.fetchCommuniques()
  },

  methods: {
    async fetchCommuniques() {
      this.loading = true
      try {
        const response = await axios.get(`${process.env.VUE_APP_URL}api/communiques`)
        if (response.data && response.data.communiques) {
          this.items = response.data.communiques
          this.dialog = new Array(this.items.length).fill(false)
        }
      } catch (err) {
        console.error('Erreur lors du chargement des communiqués', err)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
